import { render, staticRenderFns } from "./SublimeOfficeList.vue?vue&type=template&id=0519473b&scoped=true&"
import script from "./SublimeOfficeList.vue?vue&type=script&lang=ts&"
export * from "./SublimeOfficeList.vue?vue&type=script&lang=ts&"
import style0 from "./SublimeOfficeList.vue?vue&type=style&index=0&id=0519473b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0519473b",
  null
  
)

export default component.exports